var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 1920 1920"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1359.492 800.203 960 400.711 560.508 800.203l79.898 79.899 263.106-263.106-.08 822.395h113.136l-.08-822.395 263.106 263.106 79.898-79.899ZM280.863 280.863c374.484-374.484 983.79-374.484 1358.274 0 374.484 374.484 374.484 983.79 0 1358.274-374.484 374.484-983.79 374.484-1358.274 0-374.484-374.484-374.484-983.79 0-1358.274Z"
  })));
};
export default SvgArrowUp;